import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

/**
 * Picks the user-facing message out of a failed HTTP call (MP-5694).
 *
 * The backend's error handler returns `{ message, httpStatus }` for errors it raised itself
 * (validation, authorization), with a generic text for anything 5xx. So a 4xx body message is
 * safe to show as-is — e.g. "At most 50 positions can be messaged at once" — while anything
 * else falls back to the caller's wording.
 */
export function serverErrorMessage(err: any, fallback: string): string {
  const status = typeof err?.status === 'number' ? err.status : 0;
  const message = err?.error?.message;
  return status >= 400 && status < 500 && typeof message === 'string' && message.trim() ? message : fallback;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private messageService:MessageService) { }

  showSuccess(msg: string) {
    this.messageService.clear();
    this.messageService.add({ severity: 'success', summary: 'Success', detail: msg });
  }

  showError(msg: string) {
    this.messageService.clear();
    this.messageService.add({ severity: 'error', summary: '', detail: msg });
  }

  showInfo(msg: string) {
    this.messageService.clear();
    this.messageService.add({ severity: 'info', summary: '', detail: msg });
  }
}
